import { useQuery } from '@tanstack/react-query'
import { learnerProfileApi } from '@/api/learnerProfile'

export const learnerProfileKey = ['learner', 'me', 'profile'] as const

export function useLearnerProfile() {
  return useQuery({
    queryKey: learnerProfileKey,
    queryFn: async () => {
      const res = await learnerProfileApi.getProfile()
      return res.data.data
    },
    staleTime: 1000 * 60 * 5,
  })
}
